(() => {
  const STORE_CODE = /Ex(?:yn|ny)6j(?:\s*[-–—]?\s*A9)?(?:\s*AI)?/gi;
  const BRAND = 'SI Curator';
  const LABEL = 'Assistant';
  const watched = new WeakSet();
  const renameNode = node => {
    if (node.nodeType === Node.TEXT_NODE) {
      const branding = node.parentElement?.closest('[data-testid="entrypoint"],[data-testid="assistant-header"]');
      const floating = node.parentElement?.closest('[data-testid="floating-view"]');
      const header = floating?.firstElementChild;
      const inHeader = header?.contains(node.parentElement);
      const welcome = node.parentElement?.closest('h1');
      const initialWelcome = welcome && floating?.querySelector('[data-testid="agent-message-0"] h1') === welcome && /^\s*Welcome to Ex(?:yn|ny)6j/i.test(node.nodeValue);
      if (!branding && !inHeader && !initialWelcome) return;
      let next = node.nodeValue.replace(STORE_CODE, BRAND);
      if (branding || inHeader) {
        next = next.replace(/\bAI\b/g, 'SI');
        if (/^\s*Conventional Art\s*$/i.test(next)) next = BRAND;
        if (/Ex(?:yn|ny)6j.*@/i.test(node.nodeValue)) next = BRAND;
      }
      if (next !== node.nodeValue) node.nodeValue = next;
      return;
    }
    if (!node.querySelectorAll) return;
    const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) renameNode(walker.currentNode);
    const parentEntry = node.closest?.('[data-testid="entrypoint"]');
    const controls = parentEntry ? [parentEntry] : [...node.querySelectorAll('[data-testid="entrypoint"]')];
    controls.forEach(entry => entry.querySelectorAll('button,[role="button"]').forEach(button => {
      const label = button.getAttribute('aria-label') || button.textContent || '';
      if (!button.classList.contains('ca-si-launcher') && !/explore this product|(?:ai|si) shopping|shop with (?:ai|si)|assistant|art curator|super intelligence/i.test(label)) return;
      button.classList.add('ca-si-launcher');
      if (button.getAttribute('aria-label') !== LABEL) button.setAttribute('aria-label', LABEL);
      if (button.getAttribute('title') !== LABEL) button.setAttribute('title', LABEL);
    }));
  };
  const connect = () => {
    const host = document.getElementById('ads-agent-host') || document.querySelector('shopify-chat,shopify-ai-assistant,[data-testid="assistant-host"]');
    const root = host?.shadowRoot;
    if (!root) return false;
    if (watched.has(root)) return true;
    watched.add(root);
    const style = document.createElement('style');
    style.textContent = `[data-testid="entrypoint"]{position:fixed!important;inset:auto 16px 24px auto!important;width:auto!important;max-width:86px!important;margin:0!important;transform:none!important;filter:none!important;z-index:40!important}.ca-si-launcher{display:flex!important;align-items:center!important;justify-content:center!important;gap:0!important;width:86px!important;min-width:86px!important;height:44px!important;min-height:44px!important;padding:0 10px!important;border:1px solid #1f3a31!important;border-radius:4px!important;background:#1f3a31!important;color:#f2f0e9!important;filter:none!important;transform:none!important;font-size:0!important;box-shadow:0 3px 12px #12141120!important;transition:background-color .15s ease!important}.ca-si-launcher>*{display:none!important}.ca-si-launcher::after{content:'Assistant';font:500 11px/1 system-ui,sans-serif}.ca-si-launcher:focus-visible{outline:2px solid #a98b52!important;outline-offset:3px}@media(max-width:749px){[data-testid="entrypoint"]{right:10px!important;bottom:calc(16px + env(safe-area-inset-bottom))!important}}@media(prefers-reduced-motion:reduce){.ca-si-launcher{transition:none!important}}`;
    root.appendChild(style);
    renameNode(root);
    new MutationObserver(records => records.forEach(record => {
      if (record.type === 'characterData') renameNode(record.target);
      else if (record.type === 'attributes') renameNode(record.target);
      else record.addedNodes.forEach(node => renameNode(node));
    })).observe(root, {childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['aria-label','title']});
    return true;
  };
  const watch = () => {
    if (connect()) return;
    const observer = new MutationObserver(() => {if (connect()) observer.disconnect();});
    observer.observe(document.documentElement, {childList:true,subtree:true});
    setTimeout(() => observer.disconnect(), 20000);
  };
  if (document.documentElement) watch();
  else document.addEventListener('DOMContentLoaded', watch, {once:true});
})();
